module.exports = __webpack_public_path__ + "img/Feature.beeda697.jpg";